import React from 'react';
import { Typography } from 'antd';

const { Title, Text } = Typography;

const SectionHeader = ({ icon, title, description, iconColor = '#1890ff', iconBgColor = '#e6f7ff' }) => {
  return (
    <div style={{ marginBottom: '8px' }}>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
        {React.cloneElement(icon, {
          style: { 
            fontSize: '20px', 
            color: iconColor, 
            marginRight: '12px',
            backgroundColor: iconBgColor,
            padding: '8px',
            borderRadius: '8px'
          }
        })}
        <Title level={3} style={{ margin: 0 }}>
          {title}
        </Title>
      </div>
      {description && (
        <Text type="secondary" style={{ fontSize: '14px', marginBottom: '16px', display: 'block' }}>
          {description}
        </Text>
      )}
    </div>
  );
};

export default SectionHeader;